import { render, staticRenderFns } from "./videoTipBox.vue?vue&type=template&id=aa320b74&scoped=true"
import script from "./videoTipBox.vue?vue&type=script&lang=js"
export * from "./videoTipBox.vue?vue&type=script&lang=js"
import style0 from "./videoTipBox.vue?vue&type=style&index=0&id=aa320b74&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa320b74",
  null
  
)

export default component.exports